import React, { useContext } from "react";
import { bool, node, string } from "prop-types";
import AssetsProvider from "../utils/AssetsProvider";
import { classes } from "../utils/classes";

const HeroWrapper = ({ isBaseUrl = true, bgImage = "", className = "", children, ...props }) => {
	const baseUrl = isBaseUrl ? useContext(AssetsProvider.context) : "";
	const styles = bgImage
		? {
				style: {
					backgroundImage: `url('${baseUrl}${bgImage}')`,
				},
		  }
		: {};

	return (
		<div className={classes("section-hero-wrapper", className)} {...styles} {...props}>
			{children}
		</div>
	);
};

HeroWrapper.propTypes = {
	isBaseUrl: bool,
	bgImage: string,
	className: string,
	children: node.isRequired,
};

export default HeroWrapper;
